<template>
  <div class="top-container">
    <el-form :inline="true" :model="formInline" style="margin-top: 10px;">
      <el-row>
        <el-col class="top-left">
          <el-form-item>
            <i class="common-icon icon-top-logo" :class="iconClass"></i>
            <span class="logo-text">{{ componentName }}</span>
          </el-form-item>
        </el-col>
        <el-col v-show="showBarRight" class="top-search-contaniner right-search-width" :class="searchIputClass">
          <span style="position:relative;display:inline-block;">
            <el-form-item>
              <slot></slot>
            </el-form-item>
            <el-form-item v-for="(item, index) in formArray" :key="index">
              <el-input v-model="formInline[item.model]" size="mini" :style="item.width?'width:202px;':'width:116px;'" :placeholder="item.label" v-if="item.type==='input'" @keyup.enter.native="searchAction"></el-input>
              <el-select v-model="formInline[item.model]" size="mini" :style="item.width?'width:202px;':'width:116px;'" :filterable="item.filterable" :placeholder="item.label" clearable :multiple="item.multiple" v-if="item.type==='select'" @change="getLinkage">
                <el-option :label="option.label" :value="option.value" v-for="(option, i) in item.options" :key="i"></el-option>
              </el-select>
              <el-date-picker :picker-options="pickerOptions" :style="item.width?'width:202px;':'width:116px;'" v-model="formInline[item.model]" size="mini" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" :placeholder="item.label" v-if="item.type==='dateTimePicker'"></el-date-picker>
              <el-checkbox v-model="formInline[item.model]" :style="item.width?'width:202px;':'width:116px;'" @change="searchAction" :label="item.label" v-if="item.type==='checkbox'"></el-checkbox>
              <el-radio v-model="formInline[item.model]" :style="item.width?'width:202px;':'width:116px;'" :label="item.label" @change="searchAction" v-if="item.type==='radio'">{{item.name}}</el-radio>
            </el-form-item>
            <el-form-item class="search-btn-container">
              <el-tooltip :content="$t('search')" placement="top" effect="light">
                <i class="icon-color_1 common-icon common-icon-search icon-search1" @click="searchAction"></i>
              </el-tooltip>
              <el-tooltip :content="$t('clear')" placement="top" effect="light">
                <i class="icon-color_1 common-icon common-icon-search icon-clear" @click="clearAction"></i>
              </el-tooltip>
            </el-form-item>
          </span>
        </el-col>
        <!-- <button style="float:right;margin-right:20px;" v-if="componentName === this.$t('erp_list')">
          {{$t('refresh')}}
        </button> -->
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { EventBus } from '../../../../common/eventBus/eventbus';
export default {
  name: 'ListSearchToobar',

  data() {
    return {
      pickerOptions: {
        disabledDate: this.disabledDate
      },
      formInline: {
        createdDate: ''
      }
    };
  },

  props: {
    formArray: {
      type: Array,
      default: () => []
    },

    componentName: {
      type: String,
      default: ''
    },

    iconName: {
      type: String,
      default: 'icon-address'
    },

    modelData: {
      type: Object,
      default: () => {}
    },

    showBarRight: {
      type: Boolean,
      default: () => {
        return true;
      }
    },

    floatRight: {
      type: Boolean,
      default: false
    }
  },

  model: {
    prop: 'modelData',
    event: 'change'
  },

  watch: {
    formInline: {
      handler(newValue, oldValue) {
        this.$emit('change', newValue);
      },
      deep: true
    }
  },

  mounted() {
    EventBus.$on('handleOkClick', () => {
      this.searchAction();
    });
  },

  created() {
    EventBus.$off('handleOkClick');
  },

  computed: {
    iconClass() {
      const temp = {};
      temp[this.iconName] = true;
      return temp;
    },

    searchIputClass() {
      return { 'search-input-right': this.floatRight };
    }
  },

  methods: {
    disabledDate(time) {
      return time.getFullYear() < 1900;
    },
    searchAction() {
      this.$emit('search');
    },

    onRefresh() {
      this.$emit('search');
    },

    clearAction() {
      this.formInline = {
        createdDate: ''
      };
    },

    getLinkage() {
      this.$forceUpdate();
      this.searchAction();
    }
  }
};
</script>

<style scoped>
.common-icon-search {
  font-size: 16px;
  line-height: 1;
  border: 2px solid #292929;
  border-radius: 50%;
  cursor: pointer;
  margin-right: 5px;
  vertical-align: middle;
  padding: 5px;
}

.common-icon-search:hover {
  background: #292929;
}

.top-left {
  width: 240px;
  text-align: left;
  padding-left: 52px;
}

.search-btn-container {
  position: absolute;
  right: -90px;
  top: 0;
}

.top-middle {
  width: 380px;
  padding-right: 60px;
  position: relative;
}

.right-search-width {
  max-width: calc(100% - 330px);
}
</style>